var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{attrs:{"value":_vm.data,"options":_vm.editorOption},on:{"change":function($event){return _vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }